import { toast } from "react-toastify";
import { endpoints, oids } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "@/services/auth";
import { getAuthToken } from "@/services/auth/OAuthApplication";

interface IProps {
  organization?: string;
  ids?: string;
  includeOrganization?: boolean; // Novo parâmetro para incluir Organization
}

export async function GetLocation({
  organization,
  ids,
  includeOrganization,
}: IProps) {
  let url = `${endpoints.WORKFLOWFHIR}/Location`;
  const params: string[] = [];

  if (organization) {
    params.push(`organization=${oids.cnpj}-${organization}`);
  }
  if (ids) {
    params.push(`_id=${ids}`);
  }
  if (includeOrganization) {
    params.push(`_include=Location:organization`);
  }

  // Adiciona _count se houver parâmetros
  if (params.length > 0) {
    params.push(`_count=250`);
    url = `${url}?${params.join("&")}`;
  }

  const headers = {
    Accept: "*/*",
    Authorization: await getAuthToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Get Location: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetLocation ", error);
      // toast.error(`GetLocation Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
